import { Component, EventEmitter, Output } from '@angular/core'
import { AppConfig } from '../../../app.config'
import { FileItem, FileUploader } from 'ng2-file-upload'
import { FileUploaderFactoryService } from '../../../services/file-uploader-factory.service'
import { AuthService } from '@tv3/services/auth.service'
import { FileSizePipe } from '@tokeet/tv3-platform'

@Component({
  selector: 'app-attachment-upload',
  templateUrl: './attachment-upload.component.html',
  styleUrls: ['./attachment-upload.component.scss'],
})
export class AttachmentUploadComponent {
  @Output() done = new EventEmitter()
  @Output() switchToRecentFiles = new EventEmitter()
  @Output() close = new EventEmitter()

  uploader: FileUploader
  files: FileItem[] = []
  results: any[] = []
  maxFileSize = 10 * 1024 * 1024
  private fileSizePipe = new FileSizePipe()

  constructor(
    private appConfig: AppConfig,
    private authService: AuthService,
    private fileUploaderFactory: FileUploaderFactoryService
  ) {
    this.uploader = this.fileUploaderFactory.create(
      {
        url: `${this.appConfig.apiUrl}/attachment`,
        autoUpload: true,
        maxFileSize: this.maxFileSize,
        queueLimit: 1,
        authToken: this.authService.token,
      },
      {
        onAfterAddingFile: (fileItem) => this.files.push(fileItem),
        onCompleteItem: (fileItem, res) => (this.results = this.results.concat(JSON.parse(res))),
        onCompleteAll: () => this.done.emit(this.results),
      }
    )
  }

  getGuideText() {
    return `File size should be less than <b>${this.fileSizePipe.transform(this.maxFileSize, 0)}</b> per file`
  }

  onRemoveFile(file: FileItem, index) {
    this.uploader.removeFromQueue(file)
    this.files.splice(index, 1)
  }
}
